export const pageVariants = {
  init: {
    opacity: 0,
    x: 1000,
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      type: "tween",
      duration: 0.5,
      when: "beforeChildren",
      staggerChildren: 0.4,
    },
  },
  exit: {
    opacity: 0,
    x: 1000,
    transition: { ease: "easeInOut" },
  },
}
